export class TrackingScripts {
  public static setGtmScript(key: string, doc: Document) {
    const dataLayer = `window.dataLayer = window.dataLayer || [];`;
    const gtm = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${key}');`;
    const srcNoScript = `https://www.googletagmanager.com/ns.html?id=${key}`;

    doc.head.appendChild(TrackingScripts.getScriptNode(dataLayer, doc, false));
    doc.head.appendChild(TrackingScripts.getScriptNode(gtm, doc, false));
    doc.body.insertBefore(TrackingScripts.getNoScriptNode(srcNoScript, doc), doc.body.firstChild);
  }

  private static getScriptNode(script: string, doc: Document, async?: boolean) {
    const node = doc.createElement('script');
    node.async = async || false;
    node.type = 'text/javascript';
    node.innerHTML = script;
    return node;
  }

  private static getNoScriptNode(srcNoScript: string, doc: Document) {
    const node = doc.createElement('noscript');
    const iframe = doc.createElement('iframe');
    iframe.src = srcNoScript;
    iframe.height = '0';
    iframe.width = '0';
    iframe.setAttribute('style', 'display:none;visibility:hidden');
    node.appendChild(iframe);
    return node;
  }

}
